import {Component, OnInit} from '@angular/core';
import {IQOSelectData} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-select-data';
import {Observable} from 'rxjs';
import {MatDialogRef} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {LocalDatePipe} from '@app/support/pipes/local-date.pipe';
import {SelectShiftDraftPopupComponent} from '@app/core/popups/select-shift-draft-popup/select-shift-draft-popup.component';
import {selectShiftTemplates} from '@app/core/store/selectors/shift-templates.selectors';
import {ShiftTemplate} from '@app/core/models/shift-template.model';
import {DeleteShiftTemplate, InsertShiftTemplate} from '@app/core/store/actions/shift-templates.actions';
import {getCurrentState} from '@app/core/helpers';

@Component({
	selector: 'app-select-shift-template-popup',
	templateUrl: './select-shift-template-popup.component.html',
	styleUrls: ['./select-shift-template-popup.component.scss'],
})
export class SelectShiftTemplatePopupComponent implements OnInit {
	public shiftTemplates$: Observable<ShiftTemplate[]> = this.store.select(selectShiftTemplates);

	public options: IQOSelectData<ShiftTemplate>[] = [];
	public selectedOption: IQOSelectData<ShiftTemplate>;

	constructor(
		public dialogRef: MatDialogRef<SelectShiftDraftPopupComponent>,
		public store: Store<IAppState>,
		public localDatePipe: LocalDatePipe
	) {
		this.shiftTemplates$.subscribe(shiftTemplates => {
			if (shiftTemplates.length === 0) {
				this.dialogRef.close();
			}
			this.options = shiftTemplates.map(shiftTemplate => ({
				data: shiftTemplate,
				text: shiftTemplate.template_name,
				additionalText: this.formatDate(shiftTemplate.created_at),
			}));
		});
	}

	public ngOnInit(): void {
	}

	public formatDate(d: string): any {
		return this.localDatePipe.transform(d);
	}

	public close(): void {
		this.dialogRef.close();
	}

	public removeShiftTemplate(): void {
		this.store.dispatch(new DeleteShiftTemplate(this.selectedOption.data.id));
	}

	insertTemplate() {
		this.store.dispatch(new InsertShiftTemplate(this.selectedOption.data, getCurrentState(this.store).schedule.selectedDates[0]));
		this.dialogRef.close();
	}

}
